import { AppThunkAction } from '../index';
import { uiInitI18n, uiI18nLang, uiI18nLangs, uiLogoLang, uiI18nCountries, uiI18nCurrencies, uiI18nEinheitensysteme, uiUser, uiMessages, uiBusy } from './actions';
import { store } from '../index';
import { UiState } from './types';
import * as i18nSystem from '../../components/i18n';
import { use } from "@appnest/lit-translate";
import axios from 'axios';
import { Kode4GrowlMessage, Kode4Growl } from '@kode4/ui';
import { loadBandbeschichtungenList, loadBandmaterialtypenList, loadGefuegeartenList, loadKuehlungsartenList, loadLeistungsvorgabenList, loadVerguetungsartenList, loadProdukteAusfuehrungenList, updateProduktempfehlungAndParameterempfehlung } from '../paramentor/thunks';

console.log('API_SERVER', process.env.API_SERVER);
console.log('API_SERVER_ABSOLUTE', process.env.API_SERVER_ABSOLUTE);

export const initI18n = ():AppThunkAction => async dispatch => {
    i18nSystem.initI18n(process.env.I18N_BUNDLE_URL || '');
    await dispatch(loadLangs());

    let lang;
    lang = navigator.language || (navigator as any).userLanguage;
    if (lang) {
      lang = lang.split('-')[0];
    }
    
    if (store.getState().auth?.decodedAccessToken?.uid) {
        const user = await store.dispatch(<any>loadUserProfile(store.getState().auth.decodedAccessToken.uid, true, false));
        if (user?.language) {
            lang = user.language;
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('lang')) {
      lang = urlParams.get('lang')
    }

    await dispatch(setLang(lang));
    await dispatch(loadCountries());
    await dispatch(loadCurrencies());
    await dispatch(loadEinheitensysteme());
    await dispatch(registerI18nInterceptors());
    dispatch(uiInitI18n(true));
    return true;
}

export const setLang = (lang:string, forceReaload:boolean = false):AppThunkAction => async (dispatch, getState) => {
    if (!(<UiState>store.getState().ui).i18nInitialized || (<UiState>store.getState().ui).lang !== lang || forceReaload) {
        await dispatch(uiI18nLang(lang));
        await use(lang);

        const html = document.querySelector('html');
        if (html?.getAttribute('lang') !== lang) {
            html?.setAttribute('lang', lang);
        }

        let logoLang = lang;

        if(lang.length > 2) {
            let splitLng = lang.split('-');

            if(splitLng.length < 2) {
                splitLng = lang.split('_');
            }

            logoLang = splitLng[0];            
        }

        store.dispatch(uiLogoLang(logoLang));
        store.dispatch(<any>loadBandmaterialtypenList(true));
        store.dispatch(<any>loadBandbeschichtungenList(true));
        store.dispatch(<any>loadVerguetungsartenList(true));
        store.dispatch(<any>loadGefuegeartenList(true));
        store.dispatch(<any>loadKuehlungsartenList(true));
        store.dispatch(<any>loadLeistungsvorgabenList(true));
        store.dispatch(<any>loadProdukteAusfuehrungenList(true));
        store.dispatch(<any>updateProduktempfehlungAndParameterempfehlung(true));
    }

    return true;
}

export const loadLangs = ():AppThunkAction => async dispatch => {
    if ((<any>window).paramasterLanguages) {
        dispatch(uiI18nLangs((<any>window).paramasterLanguages));
        return;
    }

    const response = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/system/translations/languages`);
    dispatch(uiI18nLangs(response.data));
    return;
}

export const loadCountries = ():AppThunkAction => async dispatch => {
    if ((<any>window).paramasterCountries) {
        dispatch(uiI18nCountries((<any>window).paramasterCountries));
        return;
    }

    const response = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/system/translations/countries`);
    dispatch(uiI18nCountries(response.data));
    return;
}

export const loadCurrencies = ():AppThunkAction => async dispatch => {
    if ((<any>window).paramasterCurrencies) {
        dispatch(uiI18nCurrencies((<any>window).paramasterCurrencies));
        return;
    }

    const response = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/system/translations/currencies`);
    dispatch(uiI18nCurrencies(response.data));
    return;
}

export const loadEinheitensysteme = ():AppThunkAction => async dispatch => {
    if ((<any>window).paramasterEinheitensysteme) {
        dispatch(uiI18nEinheitensysteme((<any>window).paramasterEinheitensysteme));
        return;
    }

    const response = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/system/paramaster/einheitensysteme`);
    const einheitensysteme = new Map();
    response.data.map((el:any) => {
        einheitensysteme.set(el.id, el.name);
    });
    dispatch(uiI18nEinheitensysteme(einheitensysteme));
    return;
}

let axiosRequestInteceptor:number|undefined;

export const registerI18nInterceptors = ():AppThunkAction => async (dispatch, getState) => {

    axiosRequestInteceptor = axios.interceptors.request.use(
        (config) => {
            if (!config.params) {
                config.params = {};
            }
            if (!config.params.lang) {
                config.params.lang = getState().ui.lang;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
}

export const unregisterI18nInterceptors = ():AppThunkAction => async (dispatch, getState) => {
    if (axiosRequestInteceptor) {
        axios.interceptors.request.eject(axiosRequestInteceptor);
        axiosRequestInteceptor = undefined;
    }
}

export const loadUserList = (params:URLSearchParams):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users`, { params });
        return res.data.list;

    } catch (e) {
        // console.error(e)

    } finally {
        dispatch(uiBusy(false));
    }
}

export const loadUser = (id:number, updateState:boolean = true):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/${id}`);
        if (updateState) {
            dispatch(uiUser(res.data));
        }
        return res.data;

    } catch (e) {
        // console.error(e)

    } finally {
        dispatch(uiBusy(false));
    }
}

export const updateUser = (id:number, userdata:FormData):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        const params:URLSearchParams = new URLSearchParams();
        for (let [name, value] of userdata.entries()) {
            if (!(value instanceof File)) {
                params.append(name, value);
            }
        }

        let res = await axios.put(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/${id}`, params);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}

export const confirmUser = (id:number):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.put(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/confirm/${id}`);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}

export const rejectUser = (id:number):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.put(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/reject/${id}`);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}

export const deleteUser = (id:number):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.delete(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/${id}`);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}



let userloading:boolean|number = false;

async function hashUserId(userId: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(userId);
  const buffer = await crypto.subtle.digest('SHA-256', data);
  const hashedArray = Array.from(new Uint8Array(buffer));
  const hashedUserId = hashedArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashedUserId;
}

export const loadUserProfile = (id:number, updateState:boolean = true, updateLang:boolean = true):AppThunkAction => async (dispatch, getState) => {
    if (userloading !== false) {
        return getState().ui.user;
    }
    try {
        userloading = id;
        dispatch(uiBusy(true));
        let res = await axios.get(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/profile/${id}`);
        
        // init on first load
        if (!getState().ui.user) {
          await hashUserId(res.data?.id.toString())
            .then(hashedUserId => {
              console.log('hashedUserId', hashedUserId);
              console.log('debugMode', res.data?.id === 4627);
              // ID: 4627
              // HASH: 7323374915f195ab9871a0cb72296bcef4d2a163d659d138b9029701b405ac6f

              if (window.gtag) {
                window.gtag('set', 'user_id', hashedUserId);
                window.gtag('set', 'user_properties', {
                  'internal_traffic': window.location.host !== 'paramaster.de',
                  'user_position': res.data?.position,
                });
                // reconfigure due to page reload after login
                window.gtag('config', getState().ui.gaId, {
                  'anonymize_ip': true,
                  'send_page_view': true,
                  'user_id': hashedUserId,
                  'debug_mode': res.data?.id === 4627,
                  'user_properties': {
                    'internal_traffic': window.location.host !== 'paramaster.de',
                    'user_position': res.data?.position,
                  },
                });
            }
            })
            .catch(error => {
              console.error('Error hashing user ID:', error);
            });
        }

        if (updateState) {
            await dispatch(uiUser(res.data));
        }
        const urlParams = new URLSearchParams(window.location.search);

        if (updateLang && !urlParams.get('lang')) {
            if (res.data?.language && res.data.language !== getState().ui.lang) {
                await dispatch(setLang(res.data.language));
            }
        }
        return res.data;

    } catch (e) {
        // console.error(e)

    } finally {
        userloading = false;
        dispatch(uiBusy(false));
    }
}

export const updateUserProfile = (id:number, userdata:FormData):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        const params:URLSearchParams = new URLSearchParams();
        for (let [name, value] of userdata.entries()) {
            if (!(value instanceof File)) {
                params.append(name, value);
            }
        }

        let res = await axios.put(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/profile/${id}`, params);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}

export const updateUserPassword = (id:number, userdata:FormData):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        const params:URLSearchParams = new URLSearchParams();
        for (let [name, value] of userdata.entries()) {
            if (!(value instanceof File)) {
                params.append(name, value);
            }
        }

        let res = await axios.put(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/profile/password/${id}`, params);
        return res.data.error === 0;

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}

export const signupUser = (userdata:FormData):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.post(`${process.env.API_SERVER}${process.env.API_BASE_ROUTE}/users/signup`, userdata);

    } catch (e) {
        // console.error(e)
        throw e;

    } finally {
        dispatch(uiBusy(false));
    }
}


export const loadGroupsList = (params?:URLSearchParams):AppThunkAction => async (dispatch, getState) => {
    try {
        dispatch(uiBusy(true));
        let res = await axios.get(`${process.env.AUTH_SERVER_API}/groups`);
        return res.data.list;

    } catch (e) {
        // console.error(e)

    } finally {
        dispatch(uiBusy(false));
    }
}


export const readMessage = ():AppThunkAction => (dispatch, getState):Kode4GrowlMessage|false => {

    const messages = getState().ui.messages;
    if (!messages.length) {
        return false;
    }

    const message = messages.shift();
    dispatch(uiMessages(messages));

    return message || false;
}

export const alertMessages = (growl:Kode4Growl):AppThunkAction => (dispatch, getState) => {
    let message:Kode4GrowlMessage|false = false;
    do {
        message = dispatch(<any>readMessage());
        if (message !== false) {
            growl.alert(message);
        }

     } while (message !== false);
}

